import React from 'react'
import Navbar from '../components/Navbar'
import FilteredProducts from '../components/filterProducts/FilteredProducts'
import Whychoose from '../components/home/Whychoose'
import Footer from '../components/Footer'

const ProductFilter = () => {
  return (
    <div className='pt-20'>
        <><Navbar/></>
        <><FilteredProducts/></>
        <><Whychoose/></>
        <><Footer/></>

      
    </div>
  )
}

export default ProductFilter